import React, { useState , useEffect } from 'react';
import { connect } from 'react-redux';
import { endPoints } from '../../config';
import { axiosInstnace as Axios } from '../../util/util';
import { history } from '../../history/history';

import { ToastContainer, toast } from 'react-toastify';
import { NavLink } from 'react-router-dom';
import { Tabs, Tab } from 'react-web-tabs';

import 'react-toastify/dist/ReactToastify.css';
import 'react-web-tabs/dist/react-web-tabs.css';

import AOS from 'aos';
AOS.init();
const Forget = props => {

const [email, handleEmail] = useState('')

const getEmail =e =>{
    handleEmail(e.target.value);
}

//Submit forget
const sendLink = async() =>{
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(!re.test(String(email))){
        toast.error("Please provide valid email", {
            position:toast.POSITION.BOTTOM_CENTER,
            autoClose: false,
            hideProgressBar:true,
            toastId:"1"
         });
         return;
    }
    try {
        const data = await Axios.get(endPoints.forgetpassword, {
            params:{
                email
            }
        });
        if (data.data.statusCode ===200) {
            toast.success("Reset link has been sent to your mail", {
                position:toast.POSITION.TOP_CENTER,
                autoClose: false,
                hideProgressBar:true,
                toastId:"1"
             });
             setTimeout(()=>{
                history.push({pathname:'/login'});
                //  window.location = "https://bigfmretailer.affle.com/login";
               },2000) ;
        }
        if(data.data.error &&  !toast.isActive("1")){
            toast.error("User does not exist exits", {
                position:toast.POSITION.BOTTOM_CENTER,
                
                hideProgressBar:true,
                toastId:"1"
             });
        }
      } catch (error) {

      }
}


//Return forget html
    return (
        <div>
            <title>Buyadsonbigfm</title>
            <div className="login_wrapper">
                <div className="login_bg" >
               <div className="login_circle">
                    <img className="circle1" src="../../assets/images/circle_login.png"  />
                   <div className="login_logo">  <NavLink to='/'><img src="../../assets/images/new_logo.png"/></NavLink></div>
                </div>
                 <div className="mic_wrapper">
                 <img src="../../assets/images/mic_login.png"/>
                 </div>
                </div>
                <div className="login_form_wrapper">
                    <div className="login_form_logo">
                        <img src="../../assets/images/logo_watermark.png" />
                    </div>
                    <div className="login_form">
                        <h2>WELCOME TO <span>BIGFM 92.7</span></h2>
                        <form className="forgot_password">
                        <div className="input_wrapper email_wrapper">
                            
                            <img src="../../../assets/images/ic_email.png"/>
                            <div>
                                <label>Email ID</label>
                                <input name="email" placeholder="Email ID" className="" value ={email} onChange={getEmail}/>
                             </div>
                        </div>
                        <div className="forgot_password_tab"><a className="resend_link" onClick={sendLink}>Send Reset Link</a></div>
                        <div className="back_login">
                        <NavLink to='/login'><div>Login</div></NavLink>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
}



export default connect(null, {})(Forget);


// WEBPACK FOOTER //
// ./web/components/signUp/forget.js